import React from 'react';
import { Select } from './Select';

export const renderSelect = ({
  input,
  dataList,
  placeholder,
  initialIndex,
  meta: { touched, error },
  //defaultValue,
  handleChange,
  modalTitle,
  type,
  width
}) => (
  <React.Fragment>
    <Select
      {...input}
      type={type}
      name={input.name}
      placeholder={placeholder}
      dataList={dataList}
      initialIndex={initialIndex}
      handleChangeSelect = {input.onChange}
      handleChange={handleChange}
      handleBlur={input.onBlur}
      error={touched && error}
      modalTitle={modalTitle}
      //defaultValue={defaultValue}
      width={width}
    />
  </React.Fragment>
);
